import { moneyProblems, offerAvailabilityProblems } from "./roomOffers";
const SCOPE_RANK = {
    premise: 0,
    company: 1,
    global: 2,
};
export function compareRoomOffers(a, b) {
    var _a, _b, _c, _d;
    const layer = SCOPE_RANK[a.scope] - SCOPE_RANK[b.scope];
    if (layer !== 0)
        return layer;
    const order = ((_a = a.order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.order) !== null && _b !== void 0 ? _b : 0);
    if (order !== 0)
        return order;
    const updated = ((_c = b.updatedAt) !== null && _c !== void 0 ? _c : "").localeCompare((_d = a.updatedAt) !== null && _d !== void 0 ? _d : "");
    if (updated !== 0)
        return updated;
    return a.id.localeCompare(b.id);
}
export function overriddenFieldsOf(patch) {
    if (!patch || typeof patch !== "object")
        return [];
    const out = [];
    if ("price" in patch)
        out.push("price");
    if ("availability" in patch && patch.availability !== undefined) {
        out.push("availability");
    }
    if ("imageUrl" in patch)
        out.push("imageUrl");
    return out;
}
export function appliedOverrideFields(offer, patch) {
    const stated = overriddenFieldsOf(patch);
    if (offer.action.kind !== "promotion")
        return stated;
    return stated.filter((field) => field !== "price");
}
export function applyOfferOverride(offer, patch) {
    var _a;
    const fields = overriddenFieldsOf(patch);
    if (!patch || fields.length === 0)
        return offer;
    const next = { ...offer };
    if (fields.includes("price") && offer.action.kind !== "promotion") {
        const action = { ...offer.action };
        if (patch.price == null)
            delete action.price;
        else
            action.price = patch.price;
        next.action = action;
    }
    if (fields.includes("availability")) {
        next.availability = (_a = patch.availability) !== null && _a !== void 0 ? _a : {};
    }
    if (fields.includes("imageUrl")) {
        if (patch.imageUrl == null)
            delete next.imageUrl;
        else
            next.imageUrl = patch.imageUrl;
    }
    return next;
}
export function resolveRoomOffers(input) {
    const offers = Array.isArray(input.offers) ? input.offers : [];
    const overrides = Array.isArray(input.overrides) ? input.overrides : [];
    const byOffer = new Map();
    for (const override of overrides) {
        if (!override || typeof override.offerId !== "string")
            continue;
        if (input.premiseId && override.premiseId !== input.premiseId)
            continue;
        const held = byOffer.get(override.offerId);
        if (!held || preferredOverride(override, held) === override) {
            byOffer.set(override.offerId, override);
        }
    }
    const out = [];
    for (const offer of offers) {
        const inherited = offer.scope !== "premise";
        const override = inherited ? byOffer.get(offer.id) : undefined;
        const suppressed = Boolean(override === null || override === void 0 ? void 0 : override.suppressed);
        if (suppressed && !input.includeSuppressed)
            continue;
        const patched = override
            ? applyOfferOverride(offer, override.patch)
            : offer;
        out.push({
            ...patched,
            origin: offer.scope,
            inherited,
            suppressed,
            overriddenFields: override
                ? appliedOverrideFields(offer, override.patch)
                : [],
            ...(override ? { overrideId: override.id } : {}),
        });
    }
    return out.sort(compareRoomOffers);
}
function preferredOverride(a, b) {
    var _a, _b;
    const updated = ((_a = b.updatedAt) !== null && _a !== void 0 ? _a : "").localeCompare((_b = a.updatedAt) !== null && _b !== void 0 ? _b : "");
    if (updated !== 0)
        return updated < 0 ? a : b;
    return a.id.localeCompare(b.id) <= 0 ? a : b;
}
export function offerOverrideProblems(patch) {
    if (patch === undefined)
        return [];
    if (!patch || typeof patch !== "object" || Array.isArray(patch)) {
        return ["override_invalid"];
    }
    const out = [];
    if ("price" in patch && patch.price != null) {
        out.push(...moneyProblems(patch.price));
    }
    if (patch.availability != null) {
        out.push(...offerAvailabilityProblems(patch.availability));
    }
    if ("imageUrl" in patch &&
        patch.imageUrl != null &&
        (typeof patch.imageUrl !== "string" || patch.imageUrl.trim() === "")) {
        out.push("override_image_invalid");
    }
    return [...new Set(out)];
}
